import ProductSupport from '@elem/compCommon/ProductConstructor/Support';
import { useProductStore } from '../../ProductProvider';
import GetProductData from '../GetProductData';

export default function TabSupport({ theme, generalKey }: { theme: any; generalKey: string }) {
    const { productPageData } = useProductStore();
    const { spuId } = productPageData;

    return (
        <>
            {spuId && <ProductSupport supportData={productPageData.supportData} theme={theme} spuId={productPageData.spuId} />}
            <GetProductData generalKey={generalKey} />
        </>
    );
}
